import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIIdentityProviderGetList } from './IdentityProviders.api';

export const fetchIdentityProviders = createAsyncThunk('identityProviders/fetchIdentityProviders', async () => {
    const response = await APIIdentityProviderGetList();
    return response.data;
});
